module.exports = __webpack_public_path__ + "img/collection.75592b90.svg";